import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "h-100 d-flex flex-column justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-2" }, "Seu gênero", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-2" }, "Gêneros que você atende", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_RadioInput, {
          name: "gender",
          options: _ctx.options,
          model: _ctx.v$.form.gender
        }, null, 8, ["options", "model"]),
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_RadioInput, {
          name: "accepted_gender",
          options: _ctx.acceptedGenderOptions,
          model: _ctx.v$.form.accepted_gender
        }, null, 8, ["options", "model"])
      ]),
      _createVNode(_component_FormButton, {
        form: _ctx.v$.form,
        label: "Concluir",
        loading: _ctx.submitting,
        onOnClick: _ctx.submit,
        disabled: _ctx.v$.invalid
      }, null, 8, ["form", "loading", "onOnClick", "disabled"])
    ])
  ]))
}